import { Request } from 'api';
import { AxiosResponse } from 'axios';

export interface MatchingUser {
    uuid: string;
    first_name: string;
    last_name: string;
    user_name: string;
    last_logged_in_at: string;
}

export interface PhoneLoginResponse {
    status:
        | 'phone_verified_one_account'
        | 'phone_verified_multiple_accounts'
        | 'phone_unverified'
        | 'phone_not_found';
    matching_users: MatchingUser[];
}

type ReturnType = Promise<AxiosResponse<PhoneLoginResponse>>;

const userBeginLoginWithSMS = (phone: string): ReturnType => {
    return Request.post(`/authentication/sms/begin-login`, { phone });
};

export default userBeginLoginWithSMS;
